import React from 'react';

import useClientContext from '../contexts/ClientData/ClientData';
import useJupyter from '../../utils/hooks/use_jupyter';

import CardView from '../common/CardView/CardView';
import ExternalLink from '../common/Labels/ExternalLink';

export const JupyterView = () => {
  const { jupyter } = useJupyter();
  const { isJupyterEnabled } = useClientContext();
 
  return (
    <CardView disableFullHeight>
      <ExternalLink
        to={jupyter ? jupyter.url : '/'}
        className="p-2 rounded border bg-brand flex items-center justify-center"
        size="lg"
        color={isJupyterEnabled ? 'white' : 'neutral-100'}
        hoverColor="border-light"
        activeColor="border-dark"
        backgroundColor={isJupyterEnabled ? null : 'bg-neutral-400'}
        bold
        openInNewTab
        isJupyterEnabled={isJupyterEnabled}
      >
        Launch JupyterHub
      </ExternalLink>
    </CardView>
  )
}

export default JupyterView;
